// FEMPIRE FASHION — Theme JS
// Announcement Bar JS zit inline in sections/announcement-bar.liquid

/* ── Mobile Menu ──────────────────────────────────────────── */
class MobileMenu extends HTMLElement {
  connectedCallback() {
    this.menu    = this.querySelector('.mobile-menu');
    this.toggles = document.querySelectorAll('[data-mobile-menu-toggle]');
    this.close   = this.querySelector('.mobile-menu__close');

    this.toggles.forEach(t => t.addEventListener('click', () => this.open()));
    this.close?.addEventListener('click', () => this.closeMenu());

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') this.closeMenu();
    });
  }

  open() {
    this.menu?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  closeMenu() {
    this.menu?.classList.remove('is-open');
    document.body.style.overflow = '';
  }
}
customElements.define('mobile-menu', MobileMenu);

/* ── Shop-uitklapmenu (desktop) ───────────────────────────────
   Progressive enhancement: de knop is een gewone <a href="/pages/shop">.
   Bij het laden wordt hij een knop-met-paneel; zonder JS blijft het een link. */
class NavFlyout extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('.nav-flyout__toggle');
    this.panel  = this.querySelector('.shop-flyout');
    if (!this.toggle || !this.panel) return;

    this.reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.hideTimer = null;
    this.hoverTimer = null;

    // Van link naar knop-gedrag
    this.toggle.setAttribute('role', 'button');
    this.toggle.setAttribute('aria-haspopup', 'true');
    this.toggle.setAttribute('aria-expanded', 'false');

    this.toggle.addEventListener('click', (e) => { e.preventDefault(); this.isOpen() ? this.close() : this.open(); });
    this.toggle.addEventListener('keydown', (e) => {
      if (e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); this.isOpen() ? this.close() : this.open(); }
    });

    // Hover met vertraging (opent niet als je er alleen langs beweegt)
    this.addEventListener('mouseenter', () => {
      clearTimeout(this.hideTimer);
      this.hoverTimer = setTimeout(() => this.open(), 120);
    });
    this.addEventListener('mouseleave', () => {
      clearTimeout(this.hoverTimer);
      this.hideTimer = setTimeout(() => this.close(), 200);
    });

    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.isOpen()) { this.close(); this.toggle.focus(); } });
    this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) this.close(); });
  }

  isOpen() { return this.panel.classList.contains('is-open'); }

  open() {
    clearTimeout(this.hideTimer);
    this.panel.hidden = false;
    // forceer reflow zodat de transitie loopt
    void this.panel.offsetWidth;
    this.panel.classList.add('is-open');
    this.toggle.setAttribute('aria-expanded', 'true');
  }

  close() {
    clearTimeout(this.hoverTimer);
    this.panel.classList.remove('is-open');
    this.toggle.setAttribute('aria-expanded', 'false');
    if (this.reduce) { this.panel.hidden = true; return; }
    setTimeout(() => { if (!this.isOpen()) this.panel.hidden = true; }, 250);
  }
}
customElements.define('nav-flyout', NavFlyout);

/* ── Scroll Fade ──────────────────────────────────────────── */
// Content start op opacity 0 en wordt zichtbaar bij scrollen. Faalt de
// observer (oude browser, reduced motion), dan tonen we alles direct —
// tekst mag nooit permanent onzichtbaar blijven.
(function () {
  const SEL = '.scroll-fade, .image-reveal, .rise';
  const revealAll = () =>
    document.querySelectorAll(SEL).forEach(el => el.classList.add('is-visible'));

  const reducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!('IntersectionObserver' in window) || reducedMotion) {
    document.addEventListener('DOMContentLoaded', revealAll);
    return;
  }

  // rootMargin -8% onderaan: met de kortere transitie (ronde 3) mag het element
  // later aanmelden en zie je het resultaat, niet de animatie.
  const observer = new IntersectionObserver(
    entries => entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        observer.unobserve(e.target);
      }
    }),
    { threshold: 0, rootMargin: '0px 0px -8% 0px' }
  );

  document.addEventListener('DOMContentLoaded', () => {
    const items = document.querySelectorAll(SEL);
    items.forEach(el => observer.observe(el));
    // Vangnet: wat al in beeld staat maar niet is aangemeld, alsnog tonen.
    requestAnimationFrame(() => {
      items.forEach(el => {
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-visible');
      });
    });
  });
})();

/* ── Doorzichtige header op de homepage (ronde 8 A6) ──────────
   Bovenaan de homepage is de header doorzichtig; na ~40px scrollen krijgt
   <body> de klasse .header-solid (achtergrond wordt ondoorzichtig). Alleen op
   de homepage; op andere pagina's blijft de header zoals hij is. Afgeknepen met
   requestAnimationFrame. Zonder JS blijft de header doorzichtig maar leesbaar
   dankzij de tekst-schaduw. */
(function () {
  if (!document.body.classList.contains('template-index')) return;
  var THRESHOLD = 40;
  var ticking = false;
  var solid = false;

  function apply() {
    var next = window.pageYOffset > THRESHOLD;
    if (next !== solid) {
      solid = next;
      document.body.classList.toggle('header-solid', solid);
    }
    ticking = false;
  }
  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(apply); }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  apply();   // beginstaat (bijv. bij herladen halverwege de pagina)
})();

/* ── Product Gallery Thumbs ───────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const gallery = thumb.closest('.product-gallery');
      if (!gallery) return;
      const mainImg = gallery.querySelector('.product-gallery__main img');
      if (mainImg) mainImg.src = thumb.querySelector('img')?.src;
      gallery.querySelectorAll('.product-gallery__thumb').forEach(t =>
        t.classList.remove('product-gallery__thumb--active')
      );
      thumb.classList.add('product-gallery__thumb--active');
    });
  });
});

/* ── Product variant selectie ─────────────────────────────── */
// Koppelt de optieknoppen aan echte varianten: hidden input, prijs en
// voorraadstatus worden bijgewerkt zodat de klant de gekozen variant bestelt.
document.addEventListener('DOMContentLoaded', () => {
  const dataEl = document.getElementById('product-variants-data');
  if (!dataEl) return;

  let variants;
  try { variants = JSON.parse(dataEl.textContent); } catch { return; }

  const variantInput = document.getElementById('variant-id');
  const priceEl      = document.getElementById('product-price');
  const atcBtn       = document.querySelector('.product-info__atc');
  const groups       = Array.from(document.querySelectorAll('.option-buttons'));
  if (!variantInput || !groups.length) return;

  const selectedValues = () =>
    groups.map(g => g.querySelector('.option-btn--active')?.dataset.value ?? null);

  const applyVariant = (variant) => {
    if (!variant) {
      if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Niet beschikbaar'; }
      return;
    }
    variantInput.value = variant.id;
    if (priceEl) {
      priceEl.innerHTML = variant.compare
        ? `<s>${variant.compare}</s> ${variant.price}`
        : variant.price;
    }
    if (atcBtn) {
      if (variant.cents === 0) {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Prijs op aanvraag';
      } else if (!variant.available) {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Uitverkocht';
      } else {
        atcBtn.disabled = false;
        atcBtn.textContent = 'In winkelwagen';
      }
    }
  };

  groups.forEach(group => {
    group.querySelectorAll('.option-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        group.querySelectorAll('.option-btn').forEach(b =>
          b.classList.remove('option-btn--active')
        );
        btn.classList.add('option-btn--active');

        const values = selectedValues();
        const match = variants.find(v =>
          v.options.every((opt, i) => opt === values[i])
        );
        applyVariant(match);
      });
    });
  });
});
